import { StringBooleanMap } from '@as-react/common-types';

export const cookieConsentSettingsParser = (cookieConsentSetting: string): StringBooleanMap => {
  return cookieConsentSetting.split('|').reduce((previousValue, currentValue) => {
    const cookieConsentSettingItem = currentValue.split(':');
    if (cookieConsentSettingItem.length === 2) {
      const cookieConsentSettingKey = cookieConsentSettingItem[0]!;
      const cookieConsentSettingToggleValue = cookieConsentSettingItem[1] === '1';
      return {
        ...previousValue,
        [cookieConsentSettingKey]: cookieConsentSettingToggleValue,
      };
    }
    return previousValue;
  }, {});
};
